import { render } from "./IconComponent.vue?vue&type=template&id=93147692&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import "./IconComponent.vue?vue&type=style&index=0&id=93147692&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93147692"]])

export default __exports__